import React from 'react'

import { useMediaQueryContext, useModalContext } from '@fourthwall/components'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { GetFourthwallAppModal } from '../GetFourthwallAppModal'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'INSTALL_MOBILE_APP' }>
}

export const MobileAppIncentive = ({ incentive }: Props) => {
  const { tablet } = useMediaQueryContext()
  const { open } = useModalContext()

  return (
    <Incentive
      type={incentive.type}
      icon="📱"
      label="Install our mobile app"
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Install mobile app' : 'Install',
        onClick: () => open(GetFourthwallAppModal),
      }}
    />
  )
}
